import React from "react";

const STATUS_MAP = {
    pending: {label: "Wartet", variant: "secondary"},
    processing: {label: "Läuft", variant: "info"},
    completed: {label: "Fertig", variant: "success"},
    failed: {label: "Fehler", variant: "danger"},
};

export default function StatusBadgeTableCell({id, className, children, childSwitch}) {
    const raw = React.Children.toArray(children)
        .filter((c) => typeof c === "string" || typeof c === "number")
        .map(String)
        .join("")
        .trim();

    const cfg = STATUS_MAP[raw] || {label: raw || "–", variant: "light"};

    return (
        <td key={id} className={`border px-4 py-2 text-nowrap${className ? " " + className : ""}`}>
            {childSwitch}
            <span className={`badge bg-${cfg.variant}`}>{cfg.label}</span>
        </td>
    );
}
